"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTPError = void 0;
var HTTPError = /** @class */ (function (_super) {
    __extends(HTTPError, _super);
    function HTTPError(url, method, statusCode, body, headers) {
        var _this = _super.call(this, "Request is failed with status code of ".concat(statusCode)) || this;
        _this.url = url;
        _this.method = method;
        _this.statusCode = statusCode;
        _this.body = body;
        _this.headers = headers;
        return _this;
    }
    return HTTPError;
}(Error));
exports.HTTPError = HTTPError;
//# sourceMappingURL=HTTPError.js.map